import { z } from "zod";

import { normalizeIndianPhone } from "@/lib/shared/phone";

export const signInSchema = z
	.object({
		phoneNumber: z.string().trim().min(1, "Phone number is required"),
		code: z.string(),
	})
	.superRefine((value, ctx) => {
		if (!value.phoneNumber || value.phoneNumber.trim().length === 0) {
			return;
		}

		if (normalizeIndianPhone(value.phoneNumber) === null) {
			ctx.addIssue({
				code: "custom",
				message: "Enter a valid Indian mobile number",
				path: ["phoneNumber"],
			});
		}

		if (value.code.trim().length > 0 && !/^\d{6}$/.test(value.code.trim())) {
			ctx.addIssue({
				code: "custom",
				message: "Enter the 6 digit OTP",
				path: ["code"],
			});
		}
	});
